import React, { useEffect, useState } from 'react';
import PolicyApi from '../../api/PolicyApi';
import { AuthData } from '../../context/auth';
import { PolicyData, withPolicyContext } from '../../context/policy';
import {
	StyledSectionContainer,
	StyledTitle,
	StyledTitleContainer,
} from '../common';
import DocumentsTable from '../DocumentsTable';

interface Props {
	policyData: PolicyData;
	authData: AuthData;
	isQuote?: boolean;
}

const DocumentsView = (props: Props) => {
	const {
		policyData,
		authData: { auth },
		isQuote,
	} = props;
	const { selectedQuote, policy } = policyData;

	const docs = isQuote ? selectedQuote.documents : policy.documents;
	const [documents, setDocuments] = useState(docs);

	useEffect(() => {
		let timer: any = 0;
		const fetchPolicy = async () => {
			try {
				const updatedPolicy = await PolicyApi.getPolicy(
					auth.authorizationToken,
					policy.locator,
				);
				setDocuments(updatedPolicy.data.documents);
				if (
					updatedPolicy.data.documents &&
					!updatedPolicy.data.documents.every((d) => !!d.url)
				) {
					timer = setTimeout(() => {
						fetchPolicy();
					}, 30000);
				}
			} catch (err) {
				console.error(err);
			}
		};
		if (docs && !docs.every((d) => !!d.url)) {
			fetchPolicy();
		} else {
			setDocuments(docs);
		}
		return () => clearTimeout(timer);
	}, [docs]);

	return (
		<>
			<StyledTitleContainer>
				<StyledTitle>Documents</StyledTitle>
			</StyledTitleContainer>
			<hr />
			<StyledSectionContainer>
				<DocumentsTable documents={documents} />
			</StyledSectionContainer>
		</>
	);
};

export default withPolicyContext<Props>(DocumentsView);
